import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";
import ProductContent from "../components/product/content";
import ProductRecipes from "../components/product/recipes";
import ProductRelated from "../components/product/related";
import ProductCta from "../components/product/cta";
import ImageContentCta from "../components/structured-text/blocks/image-content-cta";

const SunnysideProduct = ({ pageContext, data }) => {

  let seoTags = data?.datoCmsSunnysideProduct?.seoMetaTags

  const tags = seoTags.tags.map(tag => {
    if (tag.tagName === 'title') {
      tag.content = `${data?.datoCmsSunnysideProduct?.title} Bulk Online | Edlyn Foods`;
    }
    if (tag.tagName === 'meta') {
      if (tag.attributes.property === 'og:title' || tag.attributes.name === 'twitter:title') {
        tag.attributes.content = `${data?.datoCmsSunnysideProduct?.title} Bulk Online | Edlyn Foods`;
      }
      if (tag.attributes.property === 'og:description' || tag.attributes.name === 'twitter:description') {
        tag.attributes.content = `Bulk order ${data?.datoCmsSunnysideProduct?.title}. Edlyn Foods supports the food service industry.`;
      }
      if (tag.attributes.name === 'description') {
        tag.attributes.content = `Bulk order ${data?.datoCmsSunnysideProduct?.title}. Edlyn Foods supports the food service industry.`;
      }
    }
    return tag;
  });

  let updatedSeoMetaTags = { tags: tags }

  const getRgbColor = ({ red, green, blue }) => {
    return `rgb(${red}, ${green}, ${blue})`
  }

  let isFruit = false

  if (data?.datoCmsSunnysideProduct?.sunnysideProductCategories) {
    data?.datoCmsSunnysideProduct?.sunnysideProductCategories.forEach(category => {
      if (category.title.toLowerCase().includes('fruit') ) {
        isFruit = true
      }
    })
  }


  return (
    <>
      <DraftDebug publishedAt={data?.datoCmsSunnysideProduct?.meta?.publishedAt} />
      <HelmetDatoCms seo={updatedSeoMetaTags}>
        <body className="product-template" />
            <style type="text/css">{`
          body {
            --color-bg: ${getRgbColor(data?.datoCmsSunnysideProduct.colourBg || { red: 0, green: 0, blue: 0 })};
            --color-text: ${getRgbColor(data?.datoCmsSunnysideProduct.colourText || { red: 0, green: 0, blue: 0 })};
          }
        `}</style>
      </HelmetDatoCms>
      <ProductContent {...data?.datoCmsSunnysideProduct} form={data?.productForm} />
      { data?.datoCmsSunnysideProduct.productCta?.length > 0 && <ProductCta brand={`sunnyside`} cta={data?.datoCmsSunnysideProduct.productCta[0]} /> }
      <ProductRecipes brand={`sunnyside`} originalId={data?.datoCmsSunnysideProduct.originalId} />
      <ProductRelated related={data?.datoCmsSunnysideProduct?.related} brand={`sunnyside`} />
      { data?.datoCmsSunnysideProduct.imageContentCta?.length > 0 && <ImageContentCta isFruit={isFruit} colorBg={data?.datoCmsSunnysideProduct.colourBg} colorText={data?.datoCmsSunnysideProduct.colourText} brand={`sunnyside`} {...data?.datoCmsSunnysideProduct.imageContentCta[0]} /> }
    </>
  )
}

export const query = graphql`
  query SunnysideProductTemplate($originalId: String!) {
    datoCmsSunnysideProduct(originalId: { eq: $originalId }) {
      seoMetaTags {
        tags
      }
      originalId
      jsonLd
      meta {
        publishedAt
      }
      title
      brand
      permalink
      gallery {
        ...InternalAssetProps
      }
      sku
      size
      colourText {
        hex
        red
        green
        blue
      }
      colourBg {
        hex
        red
        green
        blue
      }
      sunnysideProductCategories {
        title
      }
      availableIn {
        label
        url {
          ... on DatoCmsEdlynProduct {
            id
            title
            permalink
          }
          ... on DatoCmsBoneProduct {
            id
            title
            permalink
          }
          ... on DatoCmsWoodsProduct {
            id
            title
            permalink
          }
          ... on DatoCmsGreenwheatProduct {
            id
            title
            permalink
          }
          ... on DatoCmsSunnysideProduct {
            id
            title
            permalink
          }
        }
      }
      richContent {
        value
      }
      ingredients {
        value
      }
      nutritionalInformation {
        label
        value
      }
      tableColumnTitleOne
      tableColumnTitleTwo
      nutritionalTable {
        label
        serveValue
        perHundredValue
      }
      allergens
      directionsStorage {
        label
        value
        richValue {
          value
        }
      }
      instructionalVideo {
        ...ExternalAssetProps
      }
      freeSample
      related {
        title
        brand
        slug
        permalink
        header
        size
        gallery {
          ...InternalAssetProps
        }
      }
      imageContentCta {
        ...ImageContentCtaProps
      }
      productCta {
        ...ProductCtaProps
      }
    }
    productForm: datoCmsForm(title: { eq: "Product Enquiry" }) {
      ...FormProps
    }
    productCta: datoCmsSingleProductCta(brand: { eq: "sunnyside" }) {
      brand
      buttons {
        ...LinkWithTitleProps
      }
      title
      image {
        ...InternalAssetProps
      }
    }
  }
`
export default SunnysideProduct
